import React from 'react';
import { StarSportsMainLogoWrapper, StarSportsMainLogo } from './star.style';
import { UniverseSwitcher } from 'src/components/UniverseSwitcher/UniverseSwitcher';

export const StarSportsLogotype = (): JSX.Element => (
    <StarSportsMainLogoWrapper>
        <StarSportsMainLogo />
        <UniverseSwitcher />
    </StarSportsMainLogoWrapper>
);
